import React from "react";

import { EMPTY_STRING } from "../../../constants";
import { PRODUCT_TYPES_ENUMS } from "../../../system/globalEnums";
import SelectDropdownFormik from "../selectDropdown/SelectDropdownFormik";
import {
  handleOnChangeTradingCardRarity,
  handleRaritiesChangeInSingleAddEdit,
  isDisableEditingInventoryFields,
  isTcgPlayerApi,
} from "../../utility";

// CardRarity is printing and rarity is rarity
const SelectCardRarity = (props) => {
  const {
    isFormik = true,
    value,
    setFieldValue,
    tradeinMargin,
    markupPresets,
    raritiesComponent,
    label = EMPTY_STRING,
    priceChartingProductInfo,
    priceChartingProductInfoComponent,
    setPriceChartingProductInfo = () => {},
    setPriceChartingProductInfoComponent = () => {},
    setIsFirstRender,
  } = props;
  const productMetaData = isFormik
    ? priceChartingProductInfo.productMetaData
    : priceChartingProductInfo;
  const isBatchModal = !isFormik;

  const handleRaritiesChange = (...e) => {
    //if the user selects already selected rarity ignore
    if (productMetaData.cardRarity === e[1]) {
      return;
    }
    if (raritiesComponent?.handleRaritiesChange) {
      raritiesComponent?.handleRaritiesChange?.(e[1]);
    }
    setFieldValue(...e);
    let updatedPriceChartingProductInfo = handleOnChangeTradingCardRarity(
      e[1],
      priceChartingProductInfo,
      tradeinMargin,
      markupPresets
    );
    setPriceChartingProductInfoComponent({
      ...updatedPriceChartingProductInfo.productMetaData,
    });
    setPriceChartingProductInfo({ ...updatedPriceChartingProductInfo });
    setIsFirstRender(false);
  };

  return (
    isTcgPlayerApi(productMetaData) && (
      <>
        {label && <label className="field-label">{label}</label>}
        <SelectDropdownFormik
          name="cardRarity"
          className={isBatchModal ? "w-100" : EMPTY_STRING}
          wrapperClassname={
            isBatchModal ? "category-dropdowns-batch-modal" : EMPTY_STRING
          }
          value={productMetaData?.cardRarity}
          disabled={isDisableEditingInventoryFields(
            productMetaData,
            isBatchModal
          )}
          setFieldValue={isBatchModal ? setFieldValue : handleRaritiesChange}
          options={productMetaData?.cardRarityList ?? []}
          noOptionsMessage={"No Printing Found"}
        />
      </>
    )
  );
};

export default SelectCardRarity;
